/**
 * Deterministic per-category page metadata used by ShopAll.
 *
 * Prerender captures a snapshot BEFORE `/api/categories` returns, so we cannot
 * rely on the category document's `description` field being available.
 *
 * Every description is hand-authored to stay at or under 160 characters and
 * names only compounds that are actually listed in that category.
 */
export const CATEGORY_META = {
  "growth-hormone-secretagogues": {
    name: "Growth-Hormone Secretagogues",
    description:
      "Growth-hormone secretagogue reference standards for in vitro research, including CJC-1295, Ipamorelin, Sermorelin and Tesamorelin. Research use only.",
  },
  "glp-family-analogs": {
    name: "GLP-Family Analogs",
    description:
      "GLP-family analog reference standards for laboratory research, including Semaglutide, Tirzepatide, Retatrutide and Cagrilintide. Research use only.",
  },
  "melanocortin-peptides": {
    name: "Melanocortin Peptides",
    description:
      "Melanocortin-receptor peptide reference standards, including Melanotan II, for in vitro lab research. Lot-tracked, signature-required. Research use only.",
  },
  "mitochondrial-peptides": {
    name: "Mitochondrial Peptides",
    description:
      "Mitochondrial-targeted reference standards for lab research, including MOTS-c, SS-31 (Elamipretide), Humanin and 5-Amino-1MQ. Research use only.",
  },
  "thymic-immune-peptides": {
    name: "Thymic & Immune Peptides",
    description:
      "Thymic and immune-pathway peptide reference standards, including Thymosin Alpha-1, TB-500, Thymogen and Thymulin, for lab research. Research use only.",
  },
  "bioregulator-peptides": {
    name: "Bioregulator Peptides",
    description:
      "Short bioregulator peptide reference standards, including Epithalon, Vilon, Cardiogen and Bronchogen, for in vitro laboratory research. Research use only.",
  },
  "copper-complex-peptides": {
    name: "Copper-Complex Peptides",
    description:
      "Copper-peptide reference standards for laboratory research, including GHK-Cu and AHK-Cu plus GHK-Cu research blends. Signature-required. Research use only.",
  },
  "neuropeptides": {
    name: "Neuropeptides",
    description:
      "Neuropeptide reference standards for laboratory research, including N-Acetyl Selank, N-Acetyl Semax, DSIP and Oxytocin. Lot-tracked. Research use only.",
  },
  "investigational-standards": {
    name: "Investigational Standards",
    description:
      "Investigational reference standards for laboratory research, including BPC-157, KPV, LL-37 and AOD-9604, plus bacteriostatic water. Research use only.",
  },
};

/** Every valid /shop/category/<slug> the router should treat as known. */
export const KNOWN_CATEGORY_SLUGS = Object.freeze(new Set(Object.keys(CATEGORY_META)));

export const SHOP_META = {
  name: "All Research Compounds",
  description:
    "Full catalog of laboratory peptide reference standards from Medical Peptide Store. Signature-required delivery, lot documentation. Research use only.",
};
